import { Component, OnDestroy, EventEmitter, OnInit, Output } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {StreamsService} from '../../../../services/streams.service'
import {SocialAuthService} from '../../../../services/social-auth.service'

@Component({
  selector: 'app-watcher-chat-elogin',
  templateUrl: './watcher-chat-elogin.component.html',
  styleUrls: ['./watcher-chat-elogin.component.scss']
})
export class WatcherChatEloginComponent implements OnInit, OnDestroy {

  
  @Output() onCancel = new EventEmitter<any>();
  @Output() onLogin  = new EventEmitter<string>();
  isKeyEnter:boolean = false;
  email:string = '';
  key:string = '';
  emailError:boolean = false;
  keyError:boolean = false;
  emailDisabled: boolean = false;
 

  constructor(
    private authService : SocialAuthService
  ){  } 


  ngOnInit(): void {
    this.isKeyEnter = localStorage.getItem('emailLogin')  ? true : false
  }
   
  validateEmail(email){
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }


  sendEmail(){


    this.emailDisabled = true
    if(!this.validateEmail(this.email)){
      this.emailError = true
      this.emailDisabled = false
      return
    } else {
      this.emailError = false
    }
 

    this.authService.postEmail(this.email).subscribe((res:any)=>{
      
      if(!res.error){

        this.isKeyEnter = true

	localStorage.setItem('emailLogin','true')

      }else{
        alert('Сталася помилка сервера')
      }

    },
    ()=>{alert('Сталася помилка сервера')},
    ()=>{
      this.emailDisabled = false
    })

  } 


cancel(){
this.isKeyEnter = false
localStorage.removeItem('emailLogin')
}

  enter(){

    if(this.key.length < 4){
      this.keyError = true
      return
    } else {
      this.keyError = false
localStorage.removeItem('emailLogin')
    }


    this.onLogin.emit(this.key)

 
  }


  ngOnDestroy(): void { 
  }


}
